/* eslint-disable eqeqeq */
import Icon from '@Atom/Icon'
import { getEmptyObjectKeys } from '@Helpers/getEmptyObjectKey'
import { makeRandomString } from '@Helpers/makeRandomString'
import { omitKeys } from '@Helpers/omitKey'
import { useDebounce } from '@Hooks/useDebounce'
import Stepper from '@Molecule/Stepper'
import RenewDataConfirmationModal from '@Molecule/_modal/RenewDataConfirmationModal'
import Images from '@Theme/Images'
import moment from 'moment'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import FifthStep from './Fifth'
import FirstStep from './First'
import FourthStep from './Fourth'
import SecondStep from './Second'
import SixthStep from './Sixth'
import ThirdStep from './Third'
import Styles from './style.module.scss'
import { fileBaseUrl } from '@Config/api'

export default function RenewDataLayout({
  syncData,
  defaultData,
  banks = []
}) {
  const { hash } = useParams()


  const [currentStep, setCurrentStep] = useState(localStorage?.getItem(`currentStep_renew_${hash}`) || 0)

  const [errorKeys, setErrorKeys] = useState([])


  const [showConfirmation, setShowConfirmation] = useState(false)


  const stepsOptions = useMemo(() => {
    return [
      {
        id: 1,
        label: "Personal Data",
        // isDone: true,
        // isDone: isDoneChecker?.first(),
      },
      {
        id: 2,
        label: "Data Keluarga",
        // isDone: isDoneChecker?.second(),
      },
      {
        id: 3,
        label: "Data Pendidikan",
        // isDone: isDoneChecker?.third(),
      },
      {
        id: 4,
        label: "Data Pekerjaan",
        // isDone: isDoneChecker?.fourth(),
      },
      {
        id: 5,
        label: "Data Prestasi",
        // isDone: isDoneChecker?.fifth(),
      },
      {
        id: 6,
        label: "Unggah Dokumen",
        // isDone: isDoneChecker?.sixth(),
      },
    ];
  }, []);


  const handleClickStep = (step) => {
    if (+step === 1 || +currentStep > +step) {
      setCurrentStep(step);
    } else if (+currentStep < +step) {
      if (stepsOptions[+currentStep - 1]?.isDone) {
        setCurrentStep(step);
      }
    }
  };

  const reverseDate = (dateStr) => {
    const arr = dateStr ? dateStr?.replaceAll('-', '/')?.split('/') : []
    return `${arr[2]}/${arr[1]}/${arr[0]}`
  }



  // eslint-disable-next-line no-unused-vars
  const maritalOptions = useMemo(() => {
    return [
      {
        value: 'TK',
        title: 'Tidak Kawin'
      },
      {
        value: 'K0',
        title: 'Kawin (0 Anak)'
      },
      {
        value: 'K1',
        title: 'Kawin (1 Anak)'
      },
      {
        value: 'K2',
        title: 'Kawin (2 Anak)'
      },
      {
        value: 'K3',
        title: 'Kawin (3 Anak)'
      },
    ]
  }, [])


  const defaultPersonalData = useMemo(() => {
    const storageData = JSON.parse(localStorage?.getItem(`personalData_renew_${hash}`))

    return {
      name: storageData?.name || defaultData?.nama,
      birthPlace: storageData?.birthPlace || defaultData?.tempat_lahir,
      birthDate: storageData?.birthDate || defaultData?.tgl_lahir?.replaceAll('Invalid date', '') ? new Date(reverseDate(defaultData?.tgl_lahir)) : '',
      gender: storageData?.gender || defaultData?.jenis_kelamin || '',
      religion: storageData?.religion || defaultData?.agama || '',
      bloodType: storageData?.bloodType || defaultData?.golongan_darah?.replaceAll('NA', '') || '',
      height: storageData?.height || (defaultData?.tinggi == 0 ? '' : defaultData?.tinggi) || '',
      weight: storageData?.weight || (defaultData?.berat == 0 ? '' : defaultData?.berat) || '',
      maritalStatus: storageData?.maritalStatus || defaultData?.status_kawin,
      familyNumber: storageData?.familyNumber || defaultData?.nomor_kk || '',
      idCardNumber: storageData?.idCardNumber || defaultData?.nomor_ktp || '',
      idCardPeriod: storageData?.idCardPeriod || defaultData?.masa_berlaku_ktp?.toUpperCase() !== 'SEUMUR HIDUP' ? defaultData?.masa_berlaku_ktp?.replaceAll('Invalid date', '') : '' || '',
      lifeTimeIDCard: storageData?.lifeTimeIDCard || defaultData?.masa_berlaku_ktp?.toUpperCase() === 'SEUMUR HIDUP' || false,
      taxNumber: storageData?.taxNumber || defaultData?.nomor_npwp?.replace(/\D/g, ''),
      noTaxNumber: storageData?.noTaxNumber || false,
      email: storageData?.email || defaultData?.email || '',
      phoneNumber: storageData?.phoneNumber || defaultData?.nomor_telp ? defaultData?.nomor_telp?.slice(2, defaultData?.nomor_telp?.length) : '',
      birthMotherName: storageData?.birthMotherName || defaultData?.nama_ibu || '',
      birthMotherPhoneNumber: storageData?.birthMotherPhoneNumber || '',

      idCardAddress: storageData?.idCardAddress || defaultData?.alamat || '',
      idCardRT: storageData?.idCardRT || defaultData?.rt || '',
      idCardRW: storageData?.idCardRW || defaultData?.rw || '',
      idCardKelurahan: storageData?.idCardKelurahan || defaultData?.kelurahan || '',
      idCardKecamatan: storageData?.idCardKecamatan || defaultData?.kecamatan || '',
      idCardCity: storageData?.idCardCity || defaultData?.kabupaten || '',
      idCardProvince: storageData?.idCardProvince || defaultData?.provinsi || '',
      idCardPostalCode: storageData?.idCardPostalCode || defaultData?.kode_pos || '',

      isDomicileTheSame: storageData?.isDomicileTheSame || false,

      domicileAddress: storageData?.domicileAddress || defaultData?.alamat_domisili?.alamat || '',
      domicileRT: storageData?.domicileRT || defaultData?.alamat_domisili?.rt || '',
      domicileRW: storageData?.domicileRW || defaultData?.alamat_domisili?.rw || '',
      domicileKelurahan: storageData?.domicileKelurahan || defaultData?.alamat_domisili?.kelurahan || '',
      domicileKecamatan: storageData?.domicileKecamatan || defaultData?.alamat_domisili?.kecamatan || '',
      domicileCity: storageData?.domicileCity || defaultData?.alamat_domisili?.kabupaten || '',
      domicileProvince: storageData?.domicileProvince || defaultData?.alamat_domisili?.provinsi || '',
      domicilePostalCode: storageData?.domicilePostalCode || defaultData?.alamat_domisili?.kode_pos || '',

      lastEducationType: storageData?.lastEducationType || defaultData?.pendidikan_terakhir || '',
      lastEducationInstitution: storageData?.lastEducationInstitution || defaultData?.nama_instansi || '',
      lastEducationFaculty: storageData?.lastEducationFaculty || defaultData?.jurusan || '',
      lastEducationGPA: storageData?.lastEducationGPA || defaultData?.nilai_akhir || '',

      emergencyContactName: storageData?.emergencyContactName || defaultData?.kontak_darurat?.nama || '',
      emergencyContactRelation: storageData?.emergencyContactRelation || defaultData?.kontak_darurat?.hubungan || '',
      emergencyContactPhoneNumber: storageData?.emergencyContactPhoneNumber || (defaultData?.kontak_darurat?.nomor_telp ? defaultData?.kontak_darurat?.nomor_telp?.replaceAll('+', '')?.slice(2, defaultData?.kontak_darurat?.nomor_telp?.length) : '') || '',
      emergencyContactAddress: storageData?.emergencyContactAddress || defaultData?.kontak_darurat?.alamat || '',
      sameHouseContactName: storageData?.sameHouseContactName || defaultData?.kontak_serumah?.nama || '',
      sameHouseContactRelation: storageData?.sameHouseContactRelation || defaultData?.kontak_serumah?.hubungan || '',
      sameHouseContactPhoneNumber: storageData?.sameHouseContactPhoneNumber || (defaultData?.kontak_serumah?.nomor_telp ? defaultData?.kontak_serumah?.nomor_telp?.replaceAll('+', '')?.slice(2, defaultData?.kontak_serumah?.nomor_telp?.length) : ''),
      sameHouseContactAddress: storageData?.sameHouseContactAddress || defaultData?.kontak_serumah?.alamat || '',
      differentHouseContactName: storageData?.differentHouseContactName || defaultData?.kontak_tidak_serumah?.nama || '',
      differentHouseContactRelation: storageData?.differentHouseContactRelation || defaultData?.kontak_tidak_serumah?.hubungan || '',
      differentHouseContactPhoneNumber: storageData?.differentHouseContactPhoneNumber || (defaultData?.kontak_tidak_serumah?.nomor_telp ? defaultData?.kontak_tidak_serumah?.nomor_telp?.replaceAll('+', '')?.slice(2, defaultData?.kontak_tidak_serumah?.nomor_telp?.length) : ''),
      differentHouseContactAddress: storageData?.differentHouseContactAddress || defaultData?.kontak_tidak_serumah?.alamat || '',

      bankName: storageData?.bankName || defaultData?.bank || '',
      accountNumber: storageData?.accountNumber || defaultData?.nomor_rekening || '',
      nearestHealthFacility: storageData?.nearestHealthFacility || defaultData?.klinik || '',

      hobby: storageData?.hobby || defaultData?.hobi || '',

      fbUsername: storageData?.fbUsername || defaultData?.facebook || '',
      igUsername: storageData?.igUsername || defaultData?.instagram || '',
      xUsername: storageData?.xUsername || defaultData?.x || '',
      linkedinUsername: storageData?.linkedinUsername || defaultData?.linkedin || ''
    }
  }, [hash, defaultData?.nama, defaultData?.tempat_lahir, defaultData?.tgl_lahir, defaultData?.jenis_kelamin, defaultData?.agama, defaultData?.golongan_darah, defaultData?.tinggi, defaultData?.berat, defaultData?.nomor_kk, defaultData?.nomor_ktp, defaultData?.masa_berlaku_ktp, defaultData?.nomor_npwp, defaultData?.email, defaultData?.nomor_telp, defaultData?.nama_ibu, defaultData?.alamat, defaultData?.rt, defaultData?.rw, defaultData?.kelurahan, defaultData?.kecamatan, defaultData?.kabupaten, defaultData?.provinsi, defaultData?.kode_pos, defaultData?.alamat_domisili?.alamat, defaultData?.alamat_domisili?.rt, defaultData?.alamat_domisili?.rw, defaultData?.alamat_domisili?.kelurahan, defaultData?.alamat_domisili?.kecamatan, defaultData?.alamat_domisili?.kabupaten, defaultData?.alamat_domisili?.provinsi, defaultData?.alamat_domisili?.kode_pos, defaultData?.pendidikan_terakhir, defaultData?.nama_instansi, defaultData?.jurusan, defaultData?.nilai_akhir, defaultData?.kontak_darurat?.nama, defaultData?.kontak_darurat?.hubungan, defaultData?.kontak_darurat?.nomor_telp, defaultData?.kontak_darurat?.alamat, defaultData?.kontak_serumah?.nama, defaultData?.kontak_serumah?.hubungan, defaultData?.kontak_serumah?.nomor_telp, defaultData?.kontak_serumah?.alamat, defaultData?.kontak_tidak_serumah?.nama, defaultData?.kontak_tidak_serumah?.hubungan, defaultData?.kontak_tidak_serumah?.nomor_telp, defaultData?.kontak_tidak_serumah?.alamat, defaultData?.bank, defaultData?.nomor_rekening, defaultData?.klinik, defaultData?.hobi, defaultData?.facebook, defaultData?.instagram, defaultData?.x, defaultData?.linkedin, defaultData?.status_kawin])


  const [personalData, setPersonalData] = useState(defaultPersonalData)



  useEffect(() => {
    if (personalData?.isDomicileTheSame) {
      setPersonalData(prev => {
        return {
          ...prev,
          domicileAddress: prev?.idCardAddress,
          domicileRT: prev?.idCardRT,
          domicileRW: prev?.idCardRW,
          domicileKelurahan: prev?.idCardKelurahan,
          domicileKecamatan: prev?.idCardKecamatan,
          domicileCity: prev?.idCardCity,
          domicileProvince: prev?.idCardProvince,
          domicilePostalCode: prev?.idCardPostalCode,
        }
      })
    }
  }, [personalData?.isDomicileTheSame])

  const [triggerRenew, setTriggerRenew] = useState('')

  const defaultFamilyData = useMemo(() => {
    const storageData = JSON.parse(localStorage?.getItem(`familyData_renew_${hash}`)) || []

    const filteredDefaultFamily = defaultData?.data_keluarga?.filter(obj => obj?.nik !== defaultData?.nomor_ktp) || []


    return [...Array(4)]?.map((_, i) => {
      return {
        id: i + 1,
        relation: storageData[i]?.relation || filteredDefaultFamily[i]?.hubungan || '',
        name: storageData[i]?.name || filteredDefaultFamily[i]?.nama || '',
        birthPlace: storageData[i]?.birthPlace || filteredDefaultFamily[i]?.tempat_lahir || '',
        birthDate: storageData[i]?.birthDate || (filteredDefaultFamily[i]?.tanggal_lahir ? reverseDate(filteredDefaultFamily[i]?.tanggal_lahir) : '') || '',
        idCardNumber: storageData[i]?.idCardNumber || filteredDefaultFamily[i]?.nik || '',
        gender: storageData[i]?.gender || filteredDefaultFamily[i]?.jenis_kelamin || '',
        workingStatus: storageData[i]?.workingStatus || filteredDefaultFamily[i]?.pekerjaan || '',
      }
    })

  }, [defaultData?.data_keluarga, defaultData?.nomor_ktp, hash])

  const [familyData, setFamilyData] = useState(defaultFamilyData)

  const defaultEducationData = useMemo(() => {
    const storageData = JSON.parse(localStorage?.getItem(`educationData_renew_${hash}`)) || []

    // {
    //   id: 1,
    //   educationType: '',
    //   yearFrom: '',
    //   yearTo: '',
    //   institutionName: '',
    //   facultyName: '',
    //   city: '',
    //   certificateNumber: '',
    //   gpa: ''
    // }

    return storageData?.length
      ?
      storageData
      :
      defaultData?.data_pendidikan?.map((obj, i) => {
        return {
          id: obj?.id || i + 1,
          educationType: obj?.type || '',
          yearFrom: obj?.startYear || '',
          yearTo: obj?.endYear || '',
          institutionName: obj?.name || '',
          facultyName: obj?.mastery || '',
          city: obj?.city || '',
          certificateNumber: obj?.certificateNumber || '',
          gpa: obj?.grade || ''
        }
      })
    // defaultData?.data_pendidikan
  }, [defaultData?.data_pendidikan, hash])



  const [educationData, setEducationData] = useState(defaultEducationData)

  const defaultJobData = useMemo(() => {
    const storageData = JSON.parse(localStorage?.getItem(`jobData_renew_${hash}`)) || []
    // {
    //   id: 1,
    //   yearFrom: '',
    //   yearTo: '',
    //   companyName: '',
    //   jobTitle: '',
    //   salary: '',
    //   companyContact: '',
    //   description: ''
    // }
    return storageData?.length
      ?
      storageData
      :
      defaultData?.data_pekerjaan?.map((obj, i) => {
        return {
          id: obj?.id || i + 1,
          yearFrom: obj?.startYear || '',
          yearTo: obj?.endYear || '',
          companyName: obj?.corpName || '',
          jobTitle: obj?.position || '',
          salary: obj?.salary || '',
          companyContact: obj?.corpContact ? obj?.corpContact?.slice(2, obj?.corpContact?.length) : '',
          description: obj?.remark
        }
      })
  }, [defaultData?.data_pekerjaan, hash])

  const [jobData, setJobData] = useState(defaultJobData)

  const defaultAchievementData = useMemo(() => {
    const storageData = JSON.parse(localStorage?.getItem(`achievementData_renew_${hash}`)) || []

    // {
    //   id: 1,
    //   year: '',
    //   achievement: '',
    //   description: ''
    // }

    return storageData?.length
      ?
      storageData
      :
      defaultData?.data_prestasi?.map((obj, i) => {
        return {
          id: obj?.id || i + 1,
          year: obj?.year || '',
          achievement: obj?.achievement || '',
          description: obj?.remark || ''
        }
      })

  }, [defaultData?.data_prestasi, hash])

  const [achievementData, setAchievementData] = useState(defaultAchievementData)

  const [documents, setDocuments] = useState({
    mandatory: [
      {
        title: 'Foto',
        type: 'FOTO',
        fileType: 'jpg',
        preview: defaultData?.dokumen?.find(obj => obj?.docType === 'FOTO')?.docUri ? fileBaseUrl + defaultData?.dokumen?.find(obj => obj?.docType === 'FOTO')?.docUri : '',
        file: null,
        name: ''
      },
      {
        title: 'KTP',
        type: 'KTP',
        fileType: 'jpg',
        file: null,
        preview: defaultData?.dokumen?.find(obj => obj?.docType === 'KTP')?.docUri ? fileBaseUrl + defaultData?.dokumen?.find(obj => obj?.docType === 'KTP')?.docUri : '',
        name: ''
      },
      {
        title: 'CV',
        type: 'CV',
        fileType: 'pdf-only',
        file: null,
        preview: defaultData?.dokumen?.find(obj => obj?.docType === 'CV')?.docUri ? fileBaseUrl + defaultData?.dokumen?.find(obj => obj?.docType === 'CV')?.docUri : '',
        iconPreview: true,
        name: ''
      },
      {
        title: 'Ijazah',
        type: 'IJAZAH',
        fileType: 'pdf-only',
        file: null,
        preview: defaultData?.dokumen?.find(obj => obj?.docType === 'IJAZAH')?.docUri ? fileBaseUrl + defaultData?.dokumen?.find(obj => obj?.docType === 'IJAZAH')?.docUri : '',
        iconPreview: true,
        name: ''
      },
      {
        title: 'Kartu Keluarga',
        type: 'KARTU KELUARGA',
        fileType: 'jpg',
        file: null,
        preview: defaultData?.dokumen?.find(obj => obj?.docType === 'KARTU KELUARGA')?.docUri ? fileBaseUrl + defaultData?.dokumen?.find(obj => obj?.docType === 'KARTU KELUARGA')?.docUri : '',
        name: ''
      },
      {
        title: 'NPWP',
        type: 'NPWP',
        fileType: 'jpg',
        file: null,
        preview: defaultData?.dokumen?.find(obj => obj?.docType === 'NPWP')?.docUri ? fileBaseUrl + defaultData?.dokumen?.find(obj => obj?.docType === 'NPWP')?.docUri : '',
        name: ''
      },
      {
        title: 'Rekening',
        type: 'REKENING',
        fileType: 'jpg',
        file: null,
        preview: defaultData?.dokumen?.find(obj => obj?.docType === 'REKENING')?.docUri ? fileBaseUrl + defaultData?.dokumen?.find(obj => obj?.docType === 'REKENING')?.docUri : '',
        name: ''
      },
    ],
    nonMandatory: [
      {
        title: 'Transkrip Nilai',
        type: 'TRANSKRIP NILAI',
        fileType: 'pdf-only',
        file: null,
        preview: defaultData?.dokumen?.find(obj => obj?.docType === 'TRANSKRIP NILAI')?.docUri ? fileBaseUrl + defaultData?.dokumen?.find(obj => obj?.docType === 'TRANSKRIP NILAI')?.docUri : '',
        iconPreview: true,
        name: ''
      },
      {
        title: 'BPJS Ketenagakerjaan',
        type: 'BPJS KETENAGAKERJAAN',
        fileType: 'jpg',
        file: null,
        preview: defaultData?.dokumen?.find(obj => obj?.docType === 'BPJS KETENAGAKERJAAN')?.docUri ? fileBaseUrl + defaultData?.dokumen?.find(obj => obj?.docType === 'BPJS KETENAGAKERJAAN')?.docUri : '',
        name: ''
      },
      {
        title: 'BPJS Kesehatan',
        type: 'BPJS KESEHATAN',
        fileType: 'jpg',
        file: null,
        preview: defaultData?.dokumen?.find(obj => obj?.docType === 'BPJS KESEHATAN')?.docUri ? fileBaseUrl + defaultData?.dokumen?.find(obj => obj?.docType === 'BPJS KESEHATAN')?.docUri : '',
        name: ''
      },
      {
        title: 'Surat Referensi Kerja',
        type: 'SURAT REFERENSI KERJA',
        fileType: 'jpg',
        file: null,
        preview: defaultData?.dokumen?.find(obj => obj?.docType === 'SURAT REFERENSI KERJA')?.docUri ? fileBaseUrl + defaultData?.dokumen?.find(obj => obj?.docType === 'SURAT REFERENSI KERJA')?.docUri : '',
        name: ''
      },
      {
        title: 'Surat Nikah',
        type: 'SURAT NIKAH',
        fileType: 'jpg',
        file: null,
        preview: defaultData?.dokumen?.find(obj => obj?.docType === 'SURAT NIKAH')?.docUri ? fileBaseUrl + defaultData?.dokumen?.find(obj => obj?.docType === 'SURAT NIKAH')?.docUri : '',
        name: ''
      },
      {
        title: 'Akte Lahir',
        type: 'AKTE LAHIR',
        fileType: 'jpg',
        file: null,
        preview: defaultData?.dokumen?.find(obj => obj?.docType === 'AKTE LAHIR')?.docUri ? fileBaseUrl + defaultData?.dokumen?.find(obj => obj?.docType === 'AKTE LAHIR')?.docUri : '',
        name: ''
      },
      {
        title: 'Surat Persetujuan Keluarga',
        type: 'SURAT PERSETUJUAN KELUARGA',
        fileType: 'jpg',
        file: null,
        preview: defaultData?.dokumen?.find(obj => obj?.docType === 'SURAT PERSETUJUAN KELUARGA')?.docUri ? fileBaseUrl + defaultData?.dokumen?.find(obj => obj?.docType === 'SURAT PERSETUJUAN KELUARGA')?.docUri : '',
        name: ''
      },
      {
        title: 'SKCK',
        type: 'SKCK',
        fileType: 'jpg',
        file: null,
        preview: defaultData?.dokumen?.find(obj => obj?.docType === 'SKCK')?.docUri ? fileBaseUrl + defaultData?.dokumen?.find(obj => obj?.docType === 'SKCK')?.docUri : '',
        name: ''
      },
      {
        title: 'Surat Keterangan Berbadan Sehat',
        type: 'SURAT KETERANGAN BERBADAN SEHAT',
        fileType: 'jpg',
        file: null,
        preview: defaultData?.dokumen?.find(obj => obj?.docType === 'SURAT KETERANGAN BERBADAN SEHAT')?.docUri ? fileBaseUrl + defaultData?.dokumen?.find(obj => obj?.docType === 'SURAT KETERANGAN BERBADAN SEHAT')?.docUri : '',
        name: ''
      },
    ],
    additional: defaultData?.dokumen?.filter(obj => obj?.docType === 'ADDITIONAL')?.map(obj=> {
      return {
        title: 'Additional',
        type: 'ADDITIONAL',
        fileType: 'pdf-only',
        file: null,
        preview: defaultData?.dokumen?.find(obj => obj?.docType === 'ADDITIONAL')?.docUri ? fileBaseUrl + defaultData?.dokumen?.find(obj => obj?.docType === 'ADDITIONAL')?.docUri : '',
        iconPreview: true,
        name: ''
      }
    })
  })

  const debouncedTriggerRenew = useDebounce(triggerRenew, 500)

  useEffect(() => {
    setTriggerRenew(makeRandomString(5))
  }, [personalData, familyData])

  const renewData = useCallback(() => {
    localStorage.setItem(`currentStep_renew_${hash}`, currentStep)
    localStorage.setItem(`personalData_renew_${hash}`, JSON.stringify(personalData))
    localStorage.setItem(`familyData_renew_${hash}`, JSON.stringify(familyData))
    localStorage.setItem(`educationData_renew_${hash}`, JSON.stringify(educationData))
    localStorage.setItem(`jobData_renew_${hash}`, JSON.stringify(jobData))
    localStorage.setItem(`achievementData_renew_${hash}`, JSON.stringify(achievementData))
  }, [achievementData, currentStep, educationData, familyData, hash, jobData, personalData])

  useEffect(() => {
    renewData()
  }, [renewData, debouncedTriggerRenew])



  const targetElement = useRef();
  const scrollingTop = (event) => {
    const elmnt = targetElement;
    elmnt.current.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "start",
    });
  };

  const familyDataToMap = useMemo(() => {
    switch (personalData?.maritalStatus) {
      case 'K0':
        return familyData?.slice(0, 1)
      case 'KAWIN (0 ANAK)':
        return familyData?.slice(0, 1)
      case 'K1':
        return familyData?.slice(0, 2)
      case 'KAWIN (1 ANAK)':
        return familyData?.slice(0, 2)
      case 'K2':
        return familyData?.slice(0, 3)
      case 'KAWIN (2 ANAK)':
        return familyData?.slice(0, 3)
      case 'K3':
        return familyData
      case 'KAWIN (>= 3 ANAK)':
        return familyData
      default:
        return []
    }
  }, [familyData, personalData?.maritalStatus])

  const checkErrorKeys = useCallback(() => {
    switch (+currentStep) {
      case 1:
        const emptyPersonalDataKeys = getEmptyObjectKeys(omitKeys(
          [
            !personalData?.lifeTimeIDCard ? 'xx' : 'idCardPeriod',
            'lifeTimeIDCard',
            !personalData?.noTaxNumber ? 'xx' : 'taxNumber',
            'noTaxNumber',
            'isDomicileTheSame',
            'hobby',
            'fbUsername',
            'igUsername',
            'xUsername',
            'linkedinUsername',
            'birthMotherName',
            'birthMotherPhoneNumber',
            'height',
            'weight',
            'idCardRT',
            'domicileRT',
            'idCardRW',
            'domicileRW',
            'idCardPostalCode',
            'domicilePostalCode',
            'lastEducationGPA',
            'sameHouseContactName',
            'sameHouseContactRelation',
            'sameHouseContactPhoneNumber',
            'sameHouseContactAddress',
            'differentHouseContactName',
            'differentHouseContactRelation',
            'differentHouseContactPhoneNumber',
            'differentHouseContactAddress',
            !personalData?.isDomicileTheSame ? 'xx' : 'domicileAddress',
            !personalData?.isDomicileTheSame ? 'xx' : 'domicileRT',
            !personalData?.isDomicileTheSame ? 'xx' : 'domicileRW',
            !personalData?.isDomicileTheSame ? 'xx' : 'domicileKelurahan',
            !personalData?.isDomicileTheSame ? 'xx' : 'domicileKecamatan',
            !personalData?.isDomicileTheSame ? 'xx' : 'domicileCity',
            !personalData?.isDomicileTheSame ? 'xx' : 'domicileProvince',
            !personalData?.isDomicileTheSame ? 'xx' : 'domicilePostalCode',
          ], personalData
        ))
        return emptyPersonalDataKeys
      case 2:

        return familyDataToMap?.map((obj, i) => {
          return getEmptyObjectKeys(obj)?.map((key) => `${key}-${i}`)
        })?.flat()
      case 3:
        if (!educationData?.length) {
          return ['noData']
        }
        return educationData?.map((obj, i) => {
          return getEmptyObjectKeys(omitKeys([
            // obj?.educationType === 'FORMAL' ? 'xx' : 'gpa',
            'facultyName',
            'gpa',
            'certificateNumber'
          ], obj))?.map((key) => `${key}-${i}`)
        })?.flat()
      case 4:
        return jobData?.map((obj, i) => {
          return getEmptyObjectKeys(omitKeys([
            'companyContact',
            'description'
          ], obj))?.map((key) => `${key}-${i}`)
        })?.flat()
      case 6:
        if (documents?.mandatory?.find(obj => !obj?.preview)) {
          return ['files required']
        } else return []
      default:
        return []
    }
  }, [currentStep, documents, educationData, familyDataToMap, jobData, personalData])


  const onClickNext = () => {
    const keys = checkErrorKeys()

    if (currentStep != 6) {
      if (keys?.length) {
        setErrorKeys(keys)
        scrollingTop()
      } else {
        setCurrentStep(+currentStep + 1)
        setErrorKeys([])
      }
    } else {
      if (documents?.mandatory?.find(obj => !obj?.preview)) {
        setErrorKeys(['files required'])
        scrollingTop()
      } else {
        setErrorKeys([])
        setShowConfirmation(true)
      }

    }
  }

  const [headerHeight, setHeaderHeight] = useState();
  const headerRef = useRef()

  const getHeight = () => {
    const newHeight = headerRef?.current?.clientHeight;
    setHeaderHeight(newHeight);
  };

  useEffect(() => {
    if (currentStep > 0) {
      getHeight();
    }
  }, [currentStep]);

  useEffect(() => {
    if (currentStep > 0) {
      window.addEventListener("resize", getHeight);
    }
  }, [currentStep]);

  const errorRef = useRef(null)

  // eslint-disable-next-line no-unused-vars
  const executeScroll = () => errorRef.current.scrollIntoView()



  const formToSend = useMemo(() => {
    const formData = new FormData()
    formData?.append('employeeId', defaultData?.nrk)
    formData?.append('name', personalData?.name)
    formData?.append('phoneNumber', '62' + personalData?.phoneNumber)
    formData?.append('email', personalData?.email)
    formData?.append('birthDate', moment(personalData?.birthDate)?.format('YYYY-MM-DD'))
    formData?.append('birthPlace', personalData?.birthPlace)
    formData?.append('idNumber', personalData?.idCardNumber)
    formData?.append('idNumberExpiricy', personalData?.lifeTimeIDCard ? 'SEUMUR HIDUP' : moment(personalData?.idCardPeriod)?.format('YYYY-MM-DD'))
    formData?.append('familyNumber', personalData?.familyNumber)
    formData?.append('gender', personalData?.gender)
    formData?.append('bankCode', banks?.find(obj => obj?.name === personalData?.bankName)?.swiftCode)
    formData?.append('bankName', personalData?.bankName)
    formData?.append('bankAccountName', personalData?.name)
    formData?.append('bankAccountNumber', personalData?.accountNumber)
    formData?.append('religion', personalData?.religion)
    formData?.append('bloodType', personalData?.bloodType)
    formData?.append('bodyHeight', personalData?.height)
    formData?.append('bodyWeight', personalData?.weight)
    formData?.append('maritalStatus', personalData?.maritalStatus)
    formData?.append('taxNumber', personalData?.noTaxNumber ? '' : personalData?.taxNumber)
    formData?.append('motherName', personalData?.birthMotherName)
    formData?.append('motherPhoneNumber', personalData?.birthMotherPhoneNumber ? '62' + personalData?.birthMotherPhoneNumber : '')

    formData?.append('address', personalData?.idCardAddress)
    formData?.append('neighbourhood', `${personalData?.idCardRT}/${personalData?.idCardRW}`)
    formData?.append('subDistrict', personalData?.idCardKelurahan)
    formData?.append('district', personalData?.idCardKecamatan)
    formData?.append('city', personalData?.idCardCity)
    formData?.append('province', personalData?.idCardProvince)
    formData?.append('postal', personalData?.idCardPostalCode)
    formData?.append('domicileAddress', personalData?.isDomicileTheSame ? personalData?.idCardAddress : personalData?.domicileAddress)
    formData?.append('domicileNeighbourhood', personalData?.isDomicileTheSame ? `${personalData?.idCardRT}/${personalData?.idCardRW}` : `${personalData?.domicileRT}/${personalData?.domicileRW}`)
    formData?.append('domicileSubDistrict', personalData?.isDomicileTheSame ? personalData?.idCardKelurahan : personalData?.domicileKelurahan)
    formData?.append('domicileDistrict', personalData?.isDomicileTheSame ? personalData?.idCardKecamatan : personalData?.domicileKecamatan)
    formData?.append('domicileCity', personalData?.isDomicileTheSame ? personalData?.idCardCity : personalData?.domicileCity)
    formData?.append('domicileProvince', personalData?.isDomicileTheSame ? personalData?.idCardProvince : personalData?.domicileProvince)
    formData?.append('domicilePostal', personalData?.isDomicileTheSame ? personalData?.idCardPostalCode : personalData?.domicilePostalCode)

    formData?.append('lastEducationType', personalData?.lastEducationType)
    formData?.append('lastEducationName', personalData?.lastEducationInstitution)
    formData?.append('lastEducationFaculty', personalData?.lastEducationFaculty)
    formData?.append('lastEducationGrade', personalData?.lastEducationGPA)

    formData?.append('emergencyContactName', personalData?.emergencyContactName)
    formData?.append('emergencyContactRelation', personalData?.emergencyContactRelation)
    formData?.append('emergencyContactNumber', personalData?.emergencyContactPhoneNumber ? '62' + personalData?.emergencyContactPhoneNumber : '')
    formData?.append('emergencyContactAddress', personalData?.emergencyContactAddress)
    formData?.append('houseHoldContactName', personalData?.sameHouseContactName)
    formData?.append('houseHoldContactRelation', personalData?.sameHouseContactRelation)
    formData?.append('houseHoldContactNumber', personalData?.sameHouseContactPhoneNumber ? '62' + personalData?.sameHouseContactPhoneNumber : '')
    formData?.append('houseHoldContactAddress', personalData?.sameHouseContactAddress)
    formData?.append('nonHouseHoldContactName', personalData?.differentHouseContactName)
    formData?.append('nonHouseHoldContactRelation', personalData?.differentHouseContactRelation)
    formData?.append('nonHouseHoldContactNumber', personalData?.differentHouseContactPhoneNumber ? '62' + personalData?.differentHouseContactPhoneNumber : '')
    formData?.append('nonHouseHoldContactAddress', personalData?.differentHouseContactAddress)
    formData?.append('nearestClinic', personalData?.nearestHealthFacility)
    formData?.append('facebook', personalData?.fbUsername)
    formData?.append('instagram', personalData?.igUsername)
    formData?.append('twitter', personalData?.xUsername)
    formData?.append('linkedin', personalData?.linkedinUsername)
    formData?.append('hobi', personalData?.hobby)

    formData?.append('familyMembers[0][relation]', '-')
    formData?.append('familyMembers[0][name]', personalData?.name)
    formData?.append('familyMembers[0][birthDate]', moment(personalData?.birthDate)?.format('YYYY-MM-DD'))
    formData?.append('familyMembers[0][birthPlace]', personalData?.birthPlace)
    formData?.append('familyMembers[0][idNumber]', personalData?.idCardNumber)
    formData?.append('familyMembers[0][gender]', personalData?.gender)
    // formData?.append('familyMembers[0][address]', personalData?.idCardAddress)
    formData?.append('familyMembers[0][job]', 'Karyawan Swasta')


    for (let i = 0; i < familyDataToMap?.length; i++) {
      formData?.append(`familyMembers[${i + 1}][relation]`, familyDataToMap[i]?.relation)
      formData?.append(`familyMembers[${i + 1}][name]`, familyDataToMap[i]?.name)
      formData?.append(`familyMembers[${i + 1}][birthDate]`, moment(familyDataToMap[i]?.birthDate)?.format('YYYY-MM-DD'))
      formData?.append(`familyMembers[${i + 1}][birthPlace]`, familyDataToMap[i]?.birthPlace)
      formData?.append(`familyMembers[${i + 1}][idNumber]`, familyDataToMap[i]?.idCardNumber)
      formData?.append(`familyMembers[${i + 1}][gender]`, familyDataToMap[i]?.gender)
      // formData?.append(`familyMembers[${i + 1}][address]`, personalData?.idCardAddress)
      formData?.append(`familyMembers[${i + 1}][job]`, familyDataToMap[i]?.workingStatus)
    }

    for (let i = 0; i < educationData?.length; i++) {
      formData?.append(`educationData[${i}][startYear]`, educationData[i]?.yearFrom)
      formData?.append(`educationData[${i}][endYear]`, educationData[i]?.yearTo)
      formData?.append(`educationData[${i}][type]`, educationData[i]?.educationType)
      formData?.append(`educationData[${i}][name]`, educationData[i]?.institutionName)
      formData?.append(`educationData[${i}][mastery]`, educationData[i]?.facultyName)
      formData?.append(`educationData[${i}][city]`, educationData[i]?.city)
      formData?.append(`educationData[${i}][certificateNumber]`, educationData[i]?.certificateNumber)
      if (educationData[i]?.educationType === 'FORMAL') {
        formData?.append(`educationData[${i}][grade]`, educationData[i]?.gpa)
      }
    }

    for (let i = 0; i < jobData?.length; i++) {
      formData?.append(`workExperiences[${i}][startYear]`, jobData[i]?.yearFrom)
      formData?.append(`workExperiences[${i}][endYear]`, jobData[i]?.yearTo)
      formData?.append(`workExperiences[${i}][corpName]`, jobData[i]?.companyName)
      formData?.append(`workExperiences[${i}][corpContact]`, jobData[i]?.companyContact ? '62' + jobData[i]?.companyContact : '')
      formData?.append(`workExperiences[${i}][position]`, jobData[i]?.jobTitle)
      formData?.append(`workExperiences[${i}][salary]`, jobData[i]?.salary)
      formData?.append(`workExperiences[${i}][remark]`, jobData[i]?.description)
    }

    for (let i = 0; i < achievementData?.length; i++) {
      formData?.append(`achievements[${i}][year]`, achievementData[i]?.year)
      formData?.append(`achievements[${i}][achievement]`, achievementData[i]?.achievement)
      formData?.append(`achievements[${i}][remark]`, achievementData[i]?.description)
    }

    const documentsToMap = [documents?.mandatory, documents?.nonMandatory, documents?.additional]?.flat()?.filter(obj => obj?.file)

    for (let i = 0; i < documentsToMap.length; i++) {
      formData?.append('types', documentsToMap[i]?.type || 'ADDITIONAL')
      formData?.append('files', documentsToMap[i]?.file)
      // formData?.append('docNumber', null)
      // formData?.append('docExpiricy', null)
    }
    return formData
  }, [achievementData, banks, defaultData?.nrk, documents?.additional, documents?.mandatory, documents?.nonMandatory, educationData, familyDataToMap, jobData, personalData?.accountNumber, personalData?.bankName, personalData?.birthDate, personalData?.birthMotherName, personalData?.birthMotherPhoneNumber, personalData?.birthPlace, personalData?.bloodType, personalData?.differentHouseContactAddress, personalData?.differentHouseContactName, personalData?.differentHouseContactPhoneNumber, personalData?.differentHouseContactRelation, personalData?.domicileAddress, personalData?.domicileCity, personalData?.domicileKecamatan, personalData?.domicileKelurahan, personalData?.domicilePostalCode, personalData?.domicileProvince, personalData?.domicileRT, personalData?.domicileRW, personalData?.email, personalData?.emergencyContactAddress, personalData?.emergencyContactName, personalData?.emergencyContactPhoneNumber, personalData?.emergencyContactRelation, personalData?.familyNumber, personalData?.fbUsername, personalData?.gender, personalData?.height, personalData?.hobby, personalData?.idCardAddress, personalData?.idCardCity, personalData?.idCardKecamatan, personalData?.idCardKelurahan, personalData?.idCardNumber, personalData?.idCardPeriod, personalData?.idCardPostalCode, personalData?.idCardProvince, personalData?.idCardRT, personalData?.idCardRW, personalData?.igUsername, personalData?.isDomicileTheSame, personalData?.lastEducationFaculty, personalData?.lastEducationGPA, personalData?.lastEducationInstitution, personalData?.lastEducationType, personalData?.lifeTimeIDCard, personalData?.linkedinUsername, personalData?.maritalStatus, personalData?.name, personalData?.nearestHealthFacility, personalData?.noTaxNumber, personalData?.phoneNumber, personalData?.religion, personalData?.sameHouseContactAddress, personalData?.sameHouseContactName, personalData?.sameHouseContactPhoneNumber, personalData?.sameHouseContactRelation, personalData?.taxNumber, personalData?.weight, personalData?.xUsername])


  const content = [
    <FirstStep
      form={personalData}
      setForm={setPersonalData}
      syncData={syncData}
      errorRef={errorRef}
      errorKeys={errorKeys}
      banks={banks}
    />,
    <SecondStep
      familyData={familyData}
      setFamilyData={setFamilyData}
      personalData={personalData}
      stepperHeight={headerHeight}
      syncData={syncData}
      familyDataToMap={familyDataToMap}
      errorKeys={errorKeys}
    />,
    <ThirdStep
      educationData={educationData}
      setEducationData={setEducationData}
      stepperHeight={headerHeight}
      errorKeys={errorKeys}
    />,
    <FourthStep
      jobData={jobData}
      setJobData={setJobData}
      stepperHeight={headerHeight}
      errorKeys={errorKeys}
    />,
    <FifthStep
      achievementData={achievementData}
      setAchievementData={setAchievementData}
      stepperHeight={headerHeight}
    />,
    <SixthStep
      documents={documents}
      setDocuments={setDocuments}
      stepperHeight={headerHeight}
    />
  ]

  const [isSuccess, setIsSuccess] = useState(false)

  const handleSuccessSend = () => {
    setIsSuccess(true)
    setCurrentStep(0)
    localStorage?.removeItem(`currentStep_renew_${hash}`)
    localStorage?.removeItem(`personalData_renew_${hash}`)
    localStorage?.removeItem(`familyData_renew_${hash}`)
    localStorage?.removeItem(`educationData_renew_${hash}`)
    localStorage?.removeItem(`jobData_renew_${hash}`)
    localStorage?.removeItem(`achievementData_renew_${hash}`)
    setShowConfirmation(false)
  }

  if (currentStep != 0) {
    return (
      <div className={Styles.outerWrapper}>
        <div ref={headerRef} className={Styles.header}>
          <div className={Styles.logo}>
            <img src={Images.KERJA365_LIGHT} alt='' />
            <div className={Styles.permata}>
              <div className={Styles.logoBG}>
                <img src={Images.LOGO_PERMATA_FOOTER} alt='' />
              </div>
              <div className={Styles.logoText}>
                <span>Powered by</span>
                <p>Permata Indonesia</p>
              </div>
            </div>
          </div>
          <div className={Styles.stepper}>
            <div className={Styles.button}>
              <button disabled={currentStep === 1} onClick={() => {
                setCurrentStep(currentStep - 1)
                setErrorKeys([])
              }}>
                <Icon icon={'arrow-left'} size={24} />
              </button>
            </div>

            <Stepper
              type="filled"
              onClick={handleClickStep}
              options={stepsOptions}
              currentStep={currentStep}
            />
            <div className={Styles.button}>
              <button disabled={currentStep === 6} onClick={onClickNext}>
                <Icon icon={'arrow-right'} size={24} />
              </button>
            </div>

          </div>

          <div className={Styles.divider} />
        </div>
        <div className={`${Styles.wrapper} ${currentStep == 3 || currentStep == 4 || currentStep == 5 ? Styles.extraPadding : ''}`}>

          <div className={Styles.autoScroll} ref={targetElement} />

          <div className={Styles.content}>
            {
              !!errorKeys?.length
              &&
              !!checkErrorKeys()?.length
              &&
              <div className={Styles.errorInfo}>
                <Icon icon={'alert-solid'} size={20} color={'#F5610D'} />
                <span>{`${(currentStep == 3 && !educationData?.length ? 'Wajib mencantumkan data pendidikan' : 'Terdapat data yang belum diisi, silahkan lengkapi data dibawah untuk dapat melanjutkan ke step selanjutnya')}`}</span>
              </div>
            }
            {content[currentStep - 1]}
          </div>
          <div className={Styles.action}>
            <button onClick={onClickNext} className={Styles.next}>{currentStep !== 6 ? 'Selanjutnya' : 'Lanjut Kirim'}</button>
          </div>
          {
            showConfirmation
            &&
            <RenewDataConfirmationModal
              show={showConfirmation}
              onCancel={() => setShowConfirmation(false)}
              onClose={handleSuccessSend}
              formToSend={formToSend}
            />

          }

        </div>
      </div>

    )
  }



  return (
    <div className={Styles.container}>
      <div className={Styles.left}>
        <div className={Styles.logoWrapper}>
          <div className={Styles.logo}>
            <img src={Images.LOGO_PERMATA_FOOTER} alt='' />
          </div>
          <span>PT Permata Indo Sejahtera</span>
        </div>
        <img className={Styles.icon} src={Images.AMICO} alt='' />
        <div className={Styles.bg} />
      </div>
      <div className={Styles.right}>
        <div className={Styles.text}>
          <h3>Halo {defaultData?.nama}!</h3>
          <span className={Styles?.first}>PT. Permata Indo Sejahtera sedang melakukan Pengkinian data karyawan, guna melengkapi serta menyelaraskan data yang telah ada.</span>
          <span className={Styles.second}>Dengan ini kami mohon bantuan anda untuk dapat mengisi formulir ini agar kami dapat meperbaharui data anda.</span>
          <span className={Styles.third}>Klik tombol dibawah ini untuk melanjutkan ke pengisian formulir</span>
        </div>
        <div className={`${Styles.info} ${defaultData?.is_filled ? Styles.filled : Styles.notFilled}`}>
          <Icon icon={defaultData?.is_filled ? 'information-solid' : 'time'} size={24} color={defaultData?.is_filled ? '#1571DE' : '#FFA928'} />
          <span>{(defaultData?.is_filled || isSuccess) ? 'Anda telah mengirim formulir pengkinian data' : `Batas waktu pengisian form sampai tanggal ${moment(defaultData?.batas_pengisian ? new Date(defaultData?.batas_pengisian) : new Date('2024/04/30'))?.format('LL')}`}</span>
        </div>

        <button onClick={() => setCurrentStep(1)}>Selanjutnya</button>

      </div>
      {
        showConfirmation
        &&
        <RenewDataConfirmationModal
          show={showConfirmation}
          onCancel={() => setShowConfirmation(false)}
          onClose={handleSuccessSend}
          formToSend={formToSend}
        />

      }
    </div>
  )
}
